export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const VIEW_NOTIFICATIONS = 'VIEW_NOTIFICATIONS';
